module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 77
// module chunks = 0 1